// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";
import { toast } from "react-toastify";
import { getFileExtension, verifyImage } from "src/utils/file";

import { Picture as StyledPicture, PictureBox } from "./styles";

type Props = {
  image: ?Object,
  photoUrl: ?string,
  handlePicture: Function
};

const Picture = ({ image, photoUrl, handlePicture }: Props) => {
  const handleImage = useCallback(
    (e: any) => {
      const file = e.target.files[0];
      const fileExtension = getFileExtension(file.name);

      if (verifyImage(fileExtension)) {
        handlePicture(file);
      } else {
        toast.error("Only images are allowed.");
      }
    },
    [handlePicture]
  );

  return (
    <PictureBox>
      <StyledPicture>
        <input
          type="file"
          id="groupImage"
          name="groupImage"
          title=""
          accept="image/*"
          onChange={handleImage}
        />

        {photoUrl ? (
          <img src={photoUrl} alt="group logo" />
        ) : image ? (
          <img src={URL.createObjectURL(image)} alt="group logo" />
        ) : (
          <span>{i18n.t(k.UPLOAD_IMAGE)}</span>
        )}
      </StyledPicture>
      <span>{i18n.t(k.EDIT1)}</span>
    </PictureBox>
  );
};

export default Picture;
